import React from "react";
import { useDeleteProgressionContainerMutation } from "../../libs/progression/api";
import { ProgressionContainer } from "../../libs/progression/types";
import { Modal } from "../Modal";

type Props = {
  openModal: string | undefined;
  setOpenModal: (modal: string | undefined) => void;
  container: ProgressionContainer | undefined;
  templatesCount: number;
};

export const DeleteContainerModal: React.FC<Props> = ({
  openModal,
  setOpenModal,
  container,
  templatesCount,
}) => {
  const [deleteContainer, { isLoading, error }] = useDeleteProgressionContainerMutation();

  const handleDelete = (deleteTemplates: boolean) => {
    if (!container) return;
    deleteContainer({ id: container.id, deleteTemplates })
      .unwrap()
      .then(() => setOpenModal(undefined))
      .catch(() => {});
  };

  if (!container) return null;

  return (
    <Modal
      title={`Elimina: ${container.name}`}
      openModal={openModal === "deleteContainer" ? "deleteContainer" : undefined}
      setOpenModal={setOpenModal}
    >
      <p className="mb-4 text-gray-600 dark:text-gray-300">
        Questo contenitore ha <strong>{templatesCount}</strong> progression{templatesCount !== 1 ? "i" : "e"}.
        Cosa vuoi fare?
      </p>
      <div className="flex flex-col gap-3">
        <button
          onClick={() => handleDelete(true)}
          disabled={isLoading}
          className="w-full px-4 py-2.5 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg disabled:opacity-50"
        >
          Elimina tutto (contenitore + progressioni)
        </button>
        <button
          onClick={() => handleDelete(false)}
          disabled={isLoading}
          className="w-full px-4 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg disabled:opacity-50"
        >
          Elimina solo il contenitore (le progressioni restano)
        </button>
        <button
          onClick={() => setOpenModal(undefined)}
          disabled={isLoading}
          className="w-full px-4 py-2.5 text-sm font-medium text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
        >
          Annulla
        </button>
      </div>
      {error && (
        <p className="mt-2 text-sm text-red-600">
          Errore durante l&apos;eliminazione.
        </p>
      )}
    </Modal>
  );
};
